import * as jQuery from 'jquery';
import * as _ from 'underscore';

import { Component, Input, OnInit } from '@angular/core';

import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { MAP_CONSTANTS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { MapComponent } from '../map/map.component';
import { MapComponentService } from '../map/map.component.service';
import { AnalyticsDataChachingService } from '../../../analytics/services/analytics.datacaching.service';

@Component({
	providers: [MapComponentService],
	selector: 'app-map-v6',
	styleUrls: ['./map-v6.component.css'],
	templateUrl: './map-v6.component.html'
})
export class MapV6Component extends MapComponent implements OnInit {
	@Input() legend: any;
	@Input() uniqueoverwriteid: string;
	@Input() georecencycirclemarkercolor: any;
	@Input() geofencecirclemarkercolor: any;
	@Input() mapboxstyles: any;
	@Input() customAccessToken: string;
	public showLiftData: boolean = false;
	public isR1101: boolean = false;

	// Overriding instance variable to avoid Streaming Audio region. Please delete this variable if Streaming Audio is enabled for this component.
	protected DEFAULT_PRODUCTS = [
		{
			productName: 'Television',
			productKey: MAP_CONSTANTS.STATE.TELEVISION_MIDCO,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasTelevision'],
			order: 1
		},
		{
			productName: 'Display',
			productKey: MAP_CONSTANTS.STATE.DISPLAY,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasDisplay'],
			order: 2
		},
		{
			productName: 'Pre Roll',
			productKey: MAP_CONSTANTS.STATE.PREROLL,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasPreroll'],
			order: 3
		},
		{
			productName: 'SEM',
			productKey: MAP_CONSTANTS.STATE.SEM,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasSem'],
			order: 4
		},
		{
			productName: 'Connected TV',
			productKey: MAP_CONSTANTS.STATE.CTV,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasCtv'],
			order: 5
		},
		{
			productName: 'Streaming Audio',
			productKey: MAP_CONSTANTS.STATE.RADIO,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasRadio'],
			order: 6
		},
		{
			productName: 'Cumulus Digital Audio',
			productKey: MAP_CONSTANTS.STATE.TRITON_AUDIO,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: false,
			flag: ['hasRadioTriton'],
			order: 7
		},
		{
			productName: 'Responsive Display',
			productKey: MAP_CONSTANTS.STATE.RESPONSIVE_DISPLAY,
			isDisabled: false,
			isDependent: false,
			isSelected: false,
			showLiftHover: true,
			flag: ['hasResponsiveDisplay'],
			order: 8
		}
	];

	get selectedState(): string {
		return this.mapComponentService.selectedState;
	}

	get liftDetails(): any[] {
		this.showLiftData = !this.isUndefinedOrNull(this.polygonLayerDetails.avgLift)
			? true
			: !this.isUndefinedOrNull(this.polygonLayerDetails.averageBaseline)
			? true
			: !this.isUndefinedOrNull(this.polygonLayerDetails.averageExposeRate)
			? true
			: false;
		if (this.polygonLayerDetails && !!this.polygonLayerDetails['showLift']) {
			return [
				{
					addDollar: true,
					attribute: 'Avg Home Value:',
					value: this.formatNumber(this.polygonLayerDetails.avgHomeValue)
				},
				{ attribute: 'Median Age:', value: this.polygonLayerDetails.avgMedianAge, addDollar: false },
				{ attribute: 'Avg Income:', value: this.formatNumber(this.polygonLayerDetails.avgIncome), addDollar: true },
				{ attribute: 'Avg# per household:', value: this.polygonLayerDetails.avgOccupancy, addDollar: false },
				...(this.polygonLayerDetails.avgLift !== undefined &&
				this.polygonLayerDetails.avgLift !== '' &&
				this.analyticsDataModel.config.version.toLowerCase() === 'r11'
					? [{ attribute: 'Digital Lift:', value: `${this.polygonLayerDetails.avgLift}x`, addDollar: false }]
					: [])
			];
		}
	}

	get geofenceCenterDetailsForMap(): any[] {
		if (this.analyticsDataModel.config.version.toLowerCase() === 'r11') {
			return [
				{
					attribute: 'Impressions',
					value: this.geofenceCenterDetails ? this.formatNumber(this.geofenceCenterDetails.total_impression_sum) : ''
				},
				{ attribute: 'Clicks', value: this.geofenceCenterDetails ? this.geofenceCenterDetails.total_click_sum : '' },
				{
					attribute: 'CTR',
					value: this.geofenceCenterDetails ? this.geofenceCenterDetails.click_through_rate + '%' : ''
				},
				{
					attribute: 'Android',
					value: this.geofenceCenterDetails ? this.geofenceCenterDetails.total_android + '%' : ''
				},
				{ attribute: 'Apple', value: this.geofenceCenterDetails ? this.geofenceCenterDetails.total_ios + '%' : '' }
			];
		}
		return [
			{
				attribute: 'Impressions',
				value: this.geofenceCenterDetails ? this.formatNumber(this.geofenceCenterDetails.total_impression_sum) : ''
			},
			{
				attribute: 'CTR',
				value: this.geofenceCenterDetails ? this.geofenceCenterDetails.click_through_rate + '%' : ''
			},
			{ attribute: 'Clicks', value: this.geofenceCenterDetails ? this.geofenceCenterDetails.total_click_sum : '' },
			{ attribute: 'Android', value: this.geofenceCenterDetails ? this.geofenceCenterDetails.total_android + '%' : '' },
			{ attribute: 'Apple', value: this.geofenceCenterDetails ? this.geofenceCenterDetails.total_ios + '%' : '' }
		];
	}
	public colorPalette: ColorPalette;
	public circleMarkerStyles = {
		'circle-color': this.colorUtilityService.getHEXByColorType(
			this.analyticsDataModel.partner.colorPalette,
			'primary',
			1
		),
		'circle-radius': 5,
		'circle-stroke-color': '#FFF',
		'circle-stroke-width': 1
	};

	public geoFenceCircleMarkerStyles = {
		'circle-color': this.colorUtilityService.getHEXByColorType(
			this.analyticsDataModel.partner.colorPalette,
			'secondary',
			1
		),
		'circle-radius': 5,
		'circle-stroke-color': '#FFF',
		'circle-stroke-width': 1
	};

	public geoRecencyCircleMarkerStyles = {
		'circle-color': this.colorUtilityService.getHEXByColorType(
			this.analyticsDataModel.partner.colorPalette,
			'tertiary',
			1
		),
		'circle-radius': 5,
		'circle-stroke-color': '#FFF',
		'circle-stroke-width': 1
	};
	protected mapStyle = 'mapbox://styles/freq-e-deek/ck94zi0o12br51isujggakaa8';
	protected miniMapStyle = 'mapbox://styles/freq-e-deek/ck94zi0o12br51isujggakaa8';
	protected mapFillColor = this.colorUtilityService.getRGBByColorType(
		this.analyticsDataModel.partner.colorPalette,
		'primary',
		0.75
	);
	protected mapFillOutlineColor = this.colorUtilityService.getRGBByColorType(
		this.analyticsDataModel.partner.colorPalette,
		'primary',
		0.8
	);

	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected colorUtilityService: ColorUtilityService,
		protected mapComponentService: MapComponentService,
		protected AnalyticsDataChachingService: AnalyticsDataChachingService
	) {
		super(analyticsService, analyticsDataModel, colorUtilityService, mapComponentService, AnalyticsDataChachingService);
	}

	ngOnInit(): void {
		this.isR6 = this.analyticsDataModel.config.version.toLowerCase() === 'r6';
		this.mapCoordinates['lng'] = this.partnerCountryLngLat['lng'] - 25;
		this.mapCoordinates['lat'] = this.partnerCountryLngLat['lat'] + 1;
		this.defaultMapZoom = 2.6;
		super.ngOnInit();
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.legend = JSON.parse(decodeURI(this.legend));
		this.updateMapLegendProductByConfig(this.DEFAULT_PRODUCTS, this.legend);
		this.updateMapLegendProductByConfig(this.GF_PRODUCTS, this.legend);
	}

	// tslint:disable-next-line: prefer-method-signature
	formatNumber(value: { toString: () => { replace: (arg0: RegExp, arg1: string) => void } }): any {
		return value ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';
	}

	isUndefinedOrNull(value) {
		return value == null || value == '' || value == undefined ? true : false;
	}

	checkIfOnlyGeoFenceProductsSelected(selectedProducts: any): void {
		super.checkIfOnlyGeoFenceProductsSelected(selectedProducts);
		const gfProduct = _.findWhere(this.legendItems, { productKey: MAP_CONSTANTS.STATE.GEOFENCE });
		if (gfProduct && gfProduct.isSelected) {
			this.showGeofenceLegends = true;
		} else {
			this.showGeofenceLegends = false;
		}
	}

	protected drawGeoRecencyLayer(): void {
		this.geoRecencyCircleMarkerStyles['circle-color'] = this.colorUtilityService.getHEXByColorType(
			this.analyticsDataModel.partner.colorPalette,
			this.georecencycirclemarkercolor &&
				this.georecencycirclemarkercolor !== 'undefined' &&
				this.georecencycirclemarkercolor !== 'null'
				? this.georecencycirclemarkercolor
				: 'tertiary',
			1
		);
		this.geoFenceRecencyLayersDrawn = true;
		this.removeMapLayer('geofence_points_display_georecency');
		this.removeMapSource('geofence_points_display_georecency');
		this.removeMapLayer('geofence_points_preroll_georecency');
		this.removeMapSource('geofence_points_preroll_georecency');
		if (this.map && !this.map.getLayer('geofence_points_display_georecency')) {
			if (this.displayGeoRecencyData.features.length > 0) {
				this.map.addLayer({
					id: 'geofence_points_display_georecency',
					paint: this.geoRecencyCircleMarkerStyles,
					source: {
						data: this.displayGeoRecencyData,
						type: 'geojson'
					},
					type: 'circle'
				});
			}
		}
		if (this.map && !this.map.getLayer('geofence_points_preroll_georecency')) {
			if (this.prerollGeoRecencyData.features.length > 0) {
				this.map.addLayer({
					id: 'geofence_points_preroll_georecency',
					paint: this.geoRecencyCircleMarkerStyles,
					source: {
						data: this.prerollGeoRecencyData,
						type: 'geojson'
					},
					type: 'circle'
				});
			}
		}
	}

	protected removeGeoFenceRecencyLayer(): void {
		if (this.geoFenceRecencyLayersDrawn) {
			this.removeMapLayer('geofence_points_display_georecency');
			this.removeMapLayer('geofence_points_preroll_georecency');
		}
	}

	protected drawGeoFencePoints(): void {
		this.geoFenceCircleMarkerStyles['circle-color'] = this.colorUtilityService.getHEXByColorType(
			this.analyticsDataModel.partner.colorPalette,
			this.geofencecirclemarkercolor &&
				this.geofencecirclemarkercolor !== 'undefined' &&
				this.geofencecirclemarkercolor !== 'null'
				? this.geofencecirclemarkercolor
				: 'secondary',
			1
		);
		super.drawGeoFencePoints();
		if (this.displayGeoFenceData.features.length > 0) {
			this.removeMapLayer('geofence_points_geofence');
			this.removeMapSource('geofence_points_geofence');
			this.map.addLayer({
				id: 'geofence_points_geofence',
				paint: this.geoFenceCircleMarkerStyles,
				source: {
					data: this.displayGeoFenceData,
					type: 'geojson'
				},
				type: 'circle'
			});
		}
		if (this.prerollGeoFenceData.features.length > 0) {
			this.removeMapLayer('geovideo_points_geofence');
			this.removeMapSource('geovideo_points_geofence');
			this.map.addLayer({
				id: 'geovideo_points_geofence',
				paint: this.geoFenceCircleMarkerStyles,
				source: {
					data: this.prerollGeoFenceData,
					type: 'geojson'
				},
				type: 'circle'
			});
		}
	}

	protected removeAllGeoFenceMarkers(): void {
		super.removeAllGeoFenceMarkers();
		this.removeGeoFencePoints();
	}

	protected removeGeoFencePoints(): void {
		if (this.displayGeoFenceData) {
			this.removeMapLayer('geofence_points_geofence');
			this.removeMapSource('geofence_points_geofence');
		}
		if (this.prerollGeoFenceData) {
			this.removeMapLayer('geovideo_points_geofence');
			this.removeMapSource('geovideo_points_geofence');
		}
	}

	/**
	 * Show geofence center data on hover
	 * @param geofenceCenterPoint - geofence center object
	 */
	protected showGeofenceCenterDetails(geofenceCenterPoint: any): void {
		clearTimeout(this.detailsTimeInterval);
		this.showPolygonLayerDetailsFlag = false;
		this.showGeofenceCenterDetailsFlag = true;
		jQuery('.map-details-container').css('display', 'block');
		if (geofenceCenterPoint.is_simplifi_restricted_geopoint) {
			jQuery('.geofence-disclaimer').css('display', 'block');
		}
		this.geofenceCenterDetails = geofenceCenterPoint;
		this.geofenceCenterDetails.total_android = Math.round(
			(geofenceCenterPoint.android_impression_sum / geofenceCenterPoint.total_impression_sum) * 100
		);
		this.geofenceCenterDetails.total_ios = Math.round(
			(geofenceCenterPoint.ios_impression_sum / geofenceCenterPoint.total_impression_sum) * 100
		);

		for (const geofenceFeatureObj of this.displayGeoFenceData.features) {
			if (geofenceFeatureObj.properties.region_id === geofenceCenterPoint.region_id) {
				this.detailMapPoints = geofenceFeatureObj;
				break;
			}
		}
		for (const geofenceFeatureObj of this.prerollGeoFenceData.features) {
			if (geofenceFeatureObj.properties.region_id === geofenceCenterPoint.region_id) {
				this.detailMapPoints = geofenceFeatureObj;
				break;
			}
		}

		if (this.minimap) {
			this.geoFenceCircleMarkerStyles['circle-color'] = this.colorUtilityService.getHEXByColorType(
				this.analyticsDataModel.partner.colorPalette,
				this.geofencecirclemarkercolor &&
					this.geofencecirclemarkercolor !== 'undefined' &&
					this.geofencecirclemarkercolor !== 'null'
					? this.geofencecirclemarkercolor
					: 'secondary',
				1
			);
			if (this.minimap.getSource('minimap-data')) {
				if (
					Object.keys(this.detailMapPoints.geometry).length === 0 &&
					this.detailMapPoints.geometry.constructor === Object
				) {
					this.detailMapPoints.geometry = {
						type: 'MultiPoint',
						coordinates: []
					};
				}
				this.minimap.getSource('minimap-data').setData(this.detailMapPoints);
			} else {
				this.minimap.addSource('minimap-data', {
					data: this.detailMapPoints,
					type: 'geojson'
				});
				this.minimap.addLayer({
					id: 'minimap-points',
					paint: this.geoFenceCircleMarkerStyles,
					source: 'minimap-data',
					type: 'circle'
				});
			}
			this.setMapBounds(this.minimap, this.detailMapPoints, false);
		}
	}

	private updateMapLegendProductByConfig(currentProducts: any, legendItems: any): void {
		_.each(currentProducts, (item: any, index: number) => {
			const updatedMapInfo: any = _.findWhere(legendItems, { productKey: item['productKey'] });
			if (updatedMapInfo !== undefined) {
				currentProducts[index] = { ...{}, ...item, ...updatedMapInfo };
			}
		});
	}
}
